module.exports = __webpack_public_path__ + "static/media/journey-cloud-small.56fe2ae3.svg";